import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import styles from './TableLoader.module.css';

export const TableLoader = () => {
  return (
    <section data-testid="table-loader">
      <div className={styles.container}>
        <SkeletonTheme height={60}>
          <Skeleton className={styles.application} />
          <Skeleton className={styles.application} />
          <Skeleton className={styles.application} />
          <Skeleton className={styles.application} />
          <Skeleton className={styles.application} />
        </SkeletonTheme>
      </div>
    </section>
  );
};
